import * as React from "react";
import { StoredCreditCard } from "../types";
import MaskedInput from "react-text-mask";
import t from "../i18n";
import Img from "../Controls/Img";
import { CatalogService } from "src/services/catalog-service";

declare type StoredCardProps = {
  storedCard: StoredCreditCard;
  storedCreditCards: StoredCreditCard[];
  storedCreditCardChanged: (storedCard: StoredCreditCard) => void;
};
const cvvMask = [/\d/, /\d/, /\d/, /\d/];
export class StoredCreditCardComp extends React.Component<StoredCardProps> {
  //storedCreditCardChanged = (value: any, propertyName: "creditCardId" | "cvvCode") => {
  storedCreditCardChanged = (value: any, propertyName: "creditCardId" | "cvvCode" | "expiryMonthyear") => {
    if (propertyName === "creditCardId") {
      const storedCard = this.props.storedCreditCards.find((sc) => sc.creditCardId === value);
      this.props.storedCreditCardChanged(storedCard!);
    } else {
      const storedCard = this.props.storedCard;
      this.props.storedCreditCardChanged({ ...storedCard, [propertyName]: value });
    }
  };
  render() {
    const storedCard = this.props.storedCard || ({} as StoredCreditCard);
    const selectedCardId = storedCard ? storedCard.creditCardId : undefined;
    const storedCards = this.props.storedCreditCards;
    return (
      <div className="block lines" style={{ borderTopLeftRadius: 0 }}>
        {storedCards.map((c) => {
          return (
            <div className="row align-items-center" style={{ padding: "5px 0" }} key={c.creditCardId}>
              <div className="col-3 d-flex align-items-center">
                <input
                  type="radio"
                  name="selectedCreditCard"
                  value={c.creditCardId}
                  checked={c.creditCardId === selectedCardId}
                  onChange={(e) => this.storedCreditCardChanged(c.creditCardId, "creditCardId")}
                />
                <Img src={`/images/${c.cardType}.svg`} style={{ width: 32, marginLeft: 10 }} />
              </div>
              {/* <label className="col-4">{t.common("ending")} {c.creditCardNumber}</label>
                            <label className="col-2">{c.expiryMonthyear}</label>
                            <div className="col-3">
                                <MaskedInput mask={cvvMask} guide={false}
                                    value={storedCard.cvvCode || ""}
                                    onChange={e => this.storedCreditCardChanged(e.target.value, "cvvCode")}
                                    className="form-control" placeholder="CVV" maxLength={4}
                                    style={{ height: "calc(2rem + 2px)", visibility: c.creditCardId === selectedCardId ? "visible" : "hidden" }} />
                            </div> */}

              <label className="col-3">
                {t.common("ending")} {c.creditCardNumber}
              </label>
              <div className="col-2 d-flex align-items-center">
                {c.creditCardId === selectedCardId && CatalogService.checkCardExpired(c.expiryMonthyear) === true ? (
                  <input
                    type="text"
                    maxLength={5}
                    className="form-control col-8"
                    value={storedCard.expiryMonthyear}
                    onChange={(e) => this.storedCreditCardChanged(e.target.value, "expiryMonthyear")}
                    style={{ borderColor: "red" }}
                  />
                ) : (
                  <>{c.expiryMonthyear}</>
                )}
              </div>
              <div className="col-2 d-flex align-items-center">
                <MaskedInput
                  mask={cvvMask}
                  guide={false}
                  value={storedCard.cvvCode || ""}
                  onChange={(e) => this.storedCreditCardChanged(e.target.value, "cvvCode")}
                  className="form-control col-8"
                  placeholder="CVV"
                  maxLength={4}
                  style={{
                    height: "calc(2rem + 2px)",
                    visibility: c.creditCardId === selectedCardId ? "visible" : "hidden",
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
